import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    FormFeedback,
    ModalHeader,
} from "reactstrap";
import React, {useContext, useState} from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import {addProductGroup, getProducts} from "../../api/api";
import Select from "react-select";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";



const AddProductGroupButton = () => {
    const {refreshToken} = useContext(AuthContext)
    const [addProductGroupModal, setAddProductGroupModal] = useState(false);
    const toggleAddProductGroupModal = () => setAddProductGroupModal(!addProductGroupModal);

    const [productGroupName, setProductGroupName] = useState('');
    const [productGroupPrice, setProductGroupPrice] = useState('');
    const [productGroupImage, setProductGroupImage] = useState('');
    const [productOptions, setProductOptions] = useState([]);
    const [productsSupported, setProductsSupported] = useState('');
    const [productGroupRecords, setProductGroupRecords] = useState(1);
    const [productGroupDescription, setProductGroupDescription] = useState('');
    const [productGroupHSNSAC, setProductGroupHSNSAC] = useState('');
    const [productGroupUnitOfMeasure, setProductGroupUnitOfMeasure] = useState('');
    const [productGroupTaxType,setProductsGroupTaxType] = useState('');
    const [productGroupTaxPercentage, setProductGroupTaxPercentage] = useState('');
    const [advancedOptions, setAdvancedOptions] = useState(false);

    const queryClient = useQueryClient()

    const addProductGroupMutation = useMutation({
        mutationFn: addProductGroup,
        onSuccess: (data, variables) =>{
            toggleAddProductGroupModal()
            queryClient.invalidateQueries(['product-groups'])
            setProductGroupName('')
            setProductGroupPrice('')
            setProductGroupImage('')
            setProductGroupDescription('')
            setProductGroupHSNSAC('')
            setProductGroupUnitOfMeasure('')
            setProductsGroupTaxType('')
            setProductGroupTaxPercentage('')
            setAdvancedOptions(false)
            toast.success('Product Group Added!')
        },
        // retry: true,
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, addProductGroupMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })


    const handleAddProductGroupFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", productGroupName);
        formData.append("price", productGroupPrice);
        if(productsSupported) productsSupported.forEach(product => {formData.append("products", product)})
        formData.append("image", productGroupImage);
        formData.append("description", productGroupDescription);
        formData.append("hsn_sac", productGroupHSNSAC);
        formData.append("unit_of_measure", productGroupUnitOfMeasure);
        // formData.append("status", "ACTIVE");
        formData.append("tax_type", productGroupTaxType);
        formData.append("tax_percentage", productGroupTaxPercentage);
        formData.append("is_advanced_options", advancedOptions);

        addProductGroupMutation.mutate(formData)
    };

    const onSelect = (event) => {
        let newArr = []
        for(let i=0; i < event.length; i++){
            newArr.push(event[i].value)
            setProductsSupported(newArr)
        }
        setProductsSupported(newArr)
    };

    const { refetch } = useQuery({
            queryKey: ['products', productGroupRecords],
            queryFn: () => getProducts(1,'','', '','','', '', '','',
                '', '','', '','', '', productGroupRecords),
            keepPreviousData : true,
            retry: false,
            refetchOnWindowFocus: false,
            enabled: addProductGroupModal,
            onSuccess: (data =>{
                setProductGroupRecords(data?.count)
                let newOptions = []
                for(let i=0; i<data?.results?.length; i++){
                    newOptions.push({value:data?.results[i].name, label:data?.results[i].name})
                }
                setProductOptions(newOptions)
            }),
            onError: (err => {
                handleUnauthorized401QueryError(err, refreshToken, refetch)
                if(err.response.status !== 401){
                    toast.error(`An error occurred! ${err?.response?.data?.detail}`)
                }
            })
        })

    return (
        <>
            <div className="fileupload btn bx-btn-primary waves-effect waves-light mb-3" onClick={toggleAddProductGroupModal}>
                <span><i className="mdi mdi-plus-circle mr-1"/> Add Product Group</span>
            </div>

            <Modal isOpen={addProductGroupModal} toggle={toggleAddProductGroupModal} backdrop="static" keyboard={false}>
                <ModalHeader toggle={toggleAddProductGroupModal} close={
                    <button className="close" onClick={toggleAddProductGroupModal}>
                        &times;
                    </button>
                }>Add Product Group</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddProductGroupFormSubmit}>
                        <FormGroup>
                            <Label for="product-group-name">Name<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="product-group-name"
                                id="product-group-name"
                                placeholder="Product Group name"
                                value={productGroupName}
                                onChange={(e) => setProductGroupName(e.target.value)}
                                // invalid={true}

                                invalid={
                                    addProductGroupMutation.isError &&
                                    addProductGroupMutation.error.response.data.name
                                }
                            />
                            {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {addProductGroupMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="products-supported">
                                Select The Products That Supports This Product Group<span className="text-danger">*</span>
                            </Label>
                            <Select
                                options={productOptions}
                                isMulti
                                noOptionsMessage = {() => "No Product(s) found!"}
                                placeholder = "Select Products..."
                                onChange={e => onSelect(e)}
                                styles={{
                                    control: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            borderColor: "#495561",
                                            backgroundColor: "#414d59",
                                            color: "white",
                                            padding: "0.45 0.9",
                                            border: 'none',
                                            boxShadow: 'none'
                                        }
                                    ),
                                    menu: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            backgroundColor: "#414d59",
                                            color: "#a8b5c3"
                                        }
                                    ),
                                    input: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            color: "white"
                                        }
                                    )
                                }}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="product-group-price">Price<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                min="1"
                                step="any"
                                name="product-group-price"
                                id="product-group-price"
                                placeholder="Product Group Price"
                                value={productGroupPrice}
                                onChange={(e) => setProductGroupPrice(e.target.value)}
                                invalid={
                                    addProductGroupMutation.isError &&
                                    addProductGroupMutation.error.response.data.price
                                }
                            />
                            {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.price && (
                                <FormFeedback invalid>
                                    {addProductGroupMutation.error.response.data.price}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"
                                >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="product-group-description">Description</Label>
                                <Input
                                    type="textarea"
                                    name="product-group-description"
                                    id="product-group-description"
                                    value={productGroupDescription}
                                    placeholder="Product Group Description"
                                    onChange={(e) => setProductGroupDescription(e.target.value)}
                                    invalid={
                                        addProductGroupMutation.isError &&
                                        addProductGroupMutation.error.response.data.description
                                    }
                                />
                                {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.description && (
                                    <FormFeedback invalid>
                                        {addProductGroupMutation.error.response.data.description}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="HSN SAC">HSN/SAC</Label>
                                <Input
                                    type="text"
                                    name="HSN SAC"
                                    id="productHSNSAC"
                                    value={productGroupHSNSAC}
                                    placeholder="Product HSN/SAC"
                                    onChange={(e) => setProductGroupHSNSAC(e.target.value)}
                                    invalid={
                                        addProductGroupMutation.isError &&
                                        addProductGroupMutation.error.response.data.hsn_sac
                                    }
                                />
                                {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.hsn_sac && (
                                    <FormFeedback invalid>
                                        {addProductGroupMutation.error.response.data.hsn_sac}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="Unit of Measure">Unit of Measure</Label>
                                <Input
                                    type="text"
                                    name="Unit of Measure"
                                    id="Unit of Measure"
                                    value={productGroupUnitOfMeasure}
                                    placeholder="Unit of Measure"
                                    onChange={(e) => setProductGroupUnitOfMeasure(e.target.value)}
                                    invalid={
                                        addProductGroupMutation.isError &&
                                        addProductGroupMutation.error.response.data.unit_of_measure
                                    }
                                />
                                {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.unit_of_measure && (
                                    <FormFeedback invalid>
                                        {addProductGroupMutation.error.response.data.unit_of_measure}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="tax_type">Tax Type</Label>
                                <Input
                                    type="select"
                                    id="inputState"
                                    className="form-control mb-2"
                                    value={productGroupTaxType}
                                    onChange={(e) => setProductsGroupTaxType(e.target.value)}
                                >
                                    <option value="">--</option>
                                    <option value={"TAX-INCLUSIVE"}>Tax Inclusive</option>
                                    <option value={"TAX-EXCLUSIVE"}>Tax Exclusive</option>
                                </Input>
                                {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.tax_type && (
                                    <FormFeedback invalid>
                                        {addProductGroupMutation.error.response.data.tax_type}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="tax_percentage">Tax Percentage</Label>
                                <Input
                                    type="text"
                                    name="tax_percentage"
                                    id="productGroupTaxPercentage"
                                    value={productGroupTaxPercentage}
                                    placeholder="Tax Percentage"
                                    onChange={(e) => setProductGroupTaxPercentage(e.target.value)}
                                    invalid={
                                        addProductGroupMutation.isError &&
                                        addProductGroupMutation.error.response.data.tax_percentage
                                    }
                                />
                                {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.tax_percentage && (
                                    <FormFeedback invalid>
                                        {addProductGroupMutation.error.response.data.tax_percentage}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        <FormGroup>
                            <Label for="product-group-image">Image</Label>
                            <Input
                                type="file"
                                name="product-group-image"
                                id="product-group-image"
                                onChange={(e) => setProductGroupImage(e.target.files[0])}
                                invalid={
                                    addProductGroupMutation.isError &&
                                    addProductGroupMutation.error.response.data.image
                                }
                            />
                            {addProductGroupMutation.isError && addProductGroupMutation.error.response.data.image && (
                                <FormFeedback invalid>
                                    {addProductGroupMutation.error.response.data.image}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={addProductGroupMutation.isLoading}
                        >
                            {addProductGroupMutation.isLoading? <><Loader size={'small'}/>Adding Product Group...</>: `Add Product Group`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AddProductGroupButton;